// edit_tracking_links_page.js

import TrackingLinksUtils from './tracking_links_utils';
import { validate_link } from './link_validations';

document.addEventListener('alpine:init', () => {
  Alpine.data('prefix_edit_tracking_links_x_data', () => {
    // Get data from the template tag
    const template = document.getElementById('prefix-edit-tracking-links-data');
    const distribution_links = JSON.parse(template.dataset.distributionLinks);
    const all_distribution_platforms = JSON.parse(template.dataset.allDistributionPlatforms);
    const link_type = template.dataset.linkType;
    const episode_id = template.dataset.episodeId;
    const authenticity_token = template.dataset.authenticityToken;
    const batch_update_url = template.dataset.batchUpdateUrl;
    const toast_text = template.dataset.toastText;
    const redirect_only = template.dataset.redirectOnly === 'true';
    const tracking_link_ids = JSON.parse(template.dataset.trackingLinkIds || '[]');

    // Initialize data using shared utilities
    const data = TrackingLinksUtils.createInitialData();
    Object.assign(data, {
      distribution_links: distribution_links,
      all_distribution_platforms: all_distribution_platforms,
      redirect_only: redirect_only,
      redirect_url_string: '',
      selected_youtube_url: false
    });

    return {
      ...data,
      init() {
        this.linkSelector = document.querySelector("#link-selector");
        this.create_arrays();
        let that = this;
        // Listen for changes to the array and update selected_youtube_url
        this.$watch('distribution_links_truth', (newValue) => {
          that.selected_youtube_url = newValue.some(link => link.pattern === 'youtube_url');
        });
      },
      create_arrays() {
        // If redirect_only is true, we need to find the redirect_url and show only that platform
        if (this.redirect_only) {
          // Find the redirect_url in the distribution links
          let redirectUrl = null;
          let redirectPlatform = null;

          // Look for redirect_url in the distribution links
          if (this.distribution_links.redirect_url) {
            redirectUrl = this.distribution_links.redirect_url;
            // Determine which platform this URL belongs to
            redirectPlatform = this.determinePlatformFromUrl(redirectUrl);
          }

          // If we found a redirect URL and platform, show only that platform
          if (redirectUrl && redirectPlatform) {
            this.distribution_links_truth = [{
              name: redirectPlatform.name,
              pattern: redirectPlatform.pattern,
              url: redirectUrl
            }];
            this.redirect_url_string = redirectUrl; // Set the redirect_url_string
            this.create_link_elements();
            return;
          }

          // If no redirect URL found, don't create any empty elements
          this.create_empty_link_elements();
          return;
        }

        // Normal mode - use existing logic
        TrackingLinksUtils.createArrays(this, this.distribution_links, this.all_distribution_platforms);
        this.build_options_list();
        if (this.distribution_links_truth.length > 0) {
          this.create_link_elements();
        } else {
          this.create_empty_link_elements();
        }
      },
      determinePlatformFromUrl(url) {
        console.log('determinePlatformFromUrl called with:', url);
        console.log('validate_link available:', typeof validate_link === 'function');
        // Check which platform this URL belongs to by scanning through all distribution platforms
        for (const platform of this.all_distribution_platforms) {
          if (platform.pattern && validate_link(platform.pattern, url) === true) {
            console.log('Platform matched:', platform);
            return platform;
          }
        }
        // If no specific platform matches, return a generic custom platform
        console.log('No platform matched, returning custom');
        return {
          name: "Custom",
          pattern: "custom_url"
        };
      },
      create_link_elements() {
        const linksContainer = document.querySelector("#links-container");
        for (let i = 0; i < this.distribution_links_truth.length; i++) {
          const link = this.distribution_links_truth[i];
          if (link.url !== "") {
            if (link.name === "Custom") {
              const customTitle = link.title && link.title !== 'undefined' ? link.title : 'Custom Redirect Link';
              linksContainer.innerHTML += `
                <div id="${link.pattern}" class="border rounded p-4 ql-link-el" role="group" aria-labelledby="${link.pattern}-title">
                  <div class="flex space-x-4 items-center">
                    <div class="w-12 h-12">
                      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo" role="img" aria-label="${link.name} platform logo">
                    </div>
                    <div class="flex flex-col flex-1 space-y-2">
                      <div class="font-bold text-sm" id="${link.pattern}-title">${link.name}</div>
                      <div class="flex space-x-2 items-center">
                        <div class="flex space-x-2 w-full">
                            <div class="relative rounded-md shadow-sm w-full">
                                <input @keyup="$event.target.value !== '' ? $event.target.nextElementSibling.classList.remove('hidden') : $event.target.nextElementSibling.classList.add('hidden')" 
                                       id="${link.pattern}-title" 
                                       type="text" 
                                       class="block pr-10 h-9 w-full rounded border-gray-300 text-sm" 
                                       placeholder="Enter the name to be displayed" 
                                       value="${customTitle}"
                                       aria-label="Custom link display name"
                                       aria-describedby="${link.pattern}-title-help">
                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                  </svg>
                                </div>
                            </div>
                            <div class="relative rounded-md shadow-sm w-full"
                                  x-data="{ url: '${link.url}', is_valid: validate_link('${link.pattern}', '${link.url}') }"
                                  x-init="$watch('url', value => {
                                      try {
                                          if (value === '') {
                                            is_valid = null
                                          } else {
                                            is_valid = validate_link('${link.pattern}', value)
                                          }
                                      } catch (error) {
                                          console.log('Validation error:', error.message, 'for URL:', value);
                                          is_valid = false;
                                      }
                                  })"
                            >
                                <input
                                x-model="url"
                                id="${link.pattern}-url" 
                                type="text" 
                                class="block pr-10 h-9 w-full rounded border-gray-300 text-sm" 
                                placeholder="Copy and paste your custom link" 
                                value="${link.url}"
                                aria-label="Custom link URL"
                                aria-describedby="${link.pattern}-url-help">
                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === true">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                  </svg>
                                </div>
                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === false">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
                                    <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </div>
                            </div>
                        </div>

                        <svg class="cursor-pointer" 
                             @click="delete_link('${link.name}','${link.pattern}')" 
                             width="24" 
                             height="24" 
                             viewBox="0 0 24 24" 
                             fill="none" 
                             xmlns="http://www.w3.org/2000/svg"
                             role="button"
                             tabindex="0"
                             aria-label="Delete ${link.name} link"
                             @keydown.enter="delete_link('${link.name}','${link.pattern}')"
                             @keydown.space.prevent="delete_link('${link.name}','${link.pattern}')">
                          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              `;
            } else {
              linksContainer.innerHTML += `
                <div id="${link.pattern}" class="border rounded p-4 ql-link-el" role="group" aria-labelledby="${link.pattern}-title">
                  <div class="flex space-x-4 items-center">
                    <div class="w-12 h-12">
                      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo" role="img" aria-label="${link.name} platform logo">
                    </div>
                    <div class="flex flex-col flex-1 space-y-2">
                      <div class="font-bold text-sm" id="${link.pattern}-title">${link.name}</div>
                      <div class="flex space-x-2 items-center">
                        <div class="relative rounded-md shadow-sm w-full"
                              x-data="{ url: '${link.url}', is_valid: validate_link('${link.pattern}', '${link.url}') }"
                              x-init="$watch('url', value => {
                                  if (value === '') {
                                    is_valid = null
                                  } else {
                                    is_valid = validate_link('${link.pattern}', value)
                                  }
                              })"
                        >
                            <input
                            x-model="url"
                            id="${link.pattern}-url"
                            autocomplete="off"
                            type="text"
                            class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
                            placeholder="Copy and paste your ${link.name} link"
                            value="${link.url}"
                            aria-label="Enter ${link.name} link URL"
                            aria-describedby="${link.pattern}-url-help">
                            <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === true">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                              </svg>
                            </div>
                            <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                            x-show="is_valid === false">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
                                <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <svg class="cursor-pointer" 
                             @click="delete_link('${link.name}','${link.pattern}')" 
                             width="24" 
                             height="24" 
                             viewBox="0 0 24 24" 
                             fill="none" 
                             xmlns="http://www.w3.org/2000/svg"
                             role="button"
                             tabindex="0"
                             aria-label="Delete ${link.name} link"
                             @keydown.enter="delete_link('${link.name}','${link.pattern}')"
                             @keydown.space.prevent="delete_link('${link.name}','${link.pattern}')">
                          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              `;
            }
          }
        }

        // Set up event listeners for redirect-only mode
        this.setupRedirectEventListeners();
      },

      setupRedirectEventListeners() {
        if (this.redirect_only) {
          // Find all URL input fields and add event listeners
          const urlInputs = document.querySelectorAll('[id$="-url"]');
          urlInputs.forEach(input => {
            // Remove existing listeners to avoid duplicates
            input.removeEventListener('input', this.handleUrlInput);
            // Add new listener
            input.addEventListener('input', this.handleUrlInput.bind(this));
          });
        }
      },

      handleUrlInput(event) {
        if (this.redirect_only) {
          this.redirect_url_string = event.target.value;

          // Also update the distribution_links_truth array for the custom link
          const linkElements = document.querySelectorAll(".ql-link-el");
          if (linkElements.length > 0) {
            const linkElement = linkElements[0];
            const pattern = linkElement.id;

            // Find and update the corresponding link in distribution_links_truth
            for (let i = 0; i < this.distribution_links_truth.length; i++) {
              if (this.distribution_links_truth[i].pattern === pattern) {
                this.distribution_links_truth[i].url = event.target.value;
                break;
              }
            }
          }
        }
      },
      create_empty_link_elements() {
        let that = this;
        const linksContainer = document.querySelector("#links-container");

        // Don't create any default items in redirect_only mode
        if (this.redirect_only) {
          return;
        }

        const default_items = [{ name: "Apple Podcasts", pattern: "itunes_url", url: "" }, {
          name: "Spotify",
          pattern: "spotify_url",
          url: ""
        }, { name: "YouTube Music", pattern: "youtube_music_url", url: "" }];
        for (let i = 0; i < default_items.length; i++) {
          const link = default_items[i];
          that.distribution_links_truth.push({
            name: link.name,
            pattern: link.pattern,
            url: ""
          });
          linksContainer.innerHTML += `
<div id="${link.pattern}" class="border rounded p-4 ql-link-el">
  <div class="flex space-x-4 items-center">
    <div class="w-12 h-12">
      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
    </div>
    <div class="flex flex-col flex-1 space-y-2">
      <div class="font-bold text-sm">${link.name}</div>
      <div class="flex space-x-2 items-center">
        <div class="relative rounded-md shadow-sm w-full"
             x-data="{ url: '', is_valid: null }"
             x-init="$watch('url', value => {
               is_valid = value === '' ? null : validate_link('${link.pattern}', value)
             })"
        >
          <input
            x-model="url"
            id="${link.pattern}-url"
            autocomplete="off"
            type="text"
            class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
            placeholder="Copy and paste your ${link.name} link"
          >

          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
               x-show="is_valid === true">
                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                      </svg>
          </div>

          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
               x-show="is_valid === false">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
              <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')"
             width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6V20C19 20.53 18.79 21.04 18.41 21.41C18.04 21.79 17.53 22 17 22H7C6.47 22 5.96 21.79 5.59 21.41C5.21 21.04 5 20.53 5 20V6H19Z"
                stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 11V17M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
</div>
`;
          that.remove_from_options_list(link.pattern);
        }
      },
      delete_link(name, pattern) {
        TrackingLinksUtils.deleteLink(this, name, pattern);
      },
      add_to_options_list(name, pattern) {
        TrackingLinksUtils.addToOptionsList(this.add_more_options, name, pattern);
        this.build_options_list();
      },
      remove_from_options_list(pattern) {
        TrackingLinksUtils.removeFromOptionsList(this.add_more_options, pattern);
        this.build_options_list();
      },
      build_options_list() {
        TrackingLinksUtils.buildOptionsList(this.add_more_options);
        this.sync_options();
      },
      handle_add_more() {
        // In redirect_only mode, only allow one link
        if (this.redirect_only) {
          const existingLinks = document.querySelectorAll(".ql-link-el");
          if (existingLinks.length >= 1) {
            alert('You can only add one app link in redirect mode.');
            return;
          }
        }

        if (this.redirect_only) {
          // In redirect mode, show all available platforms
          this.handle_add_more_redirect_mode();
        } else {
          // Normal mode - use existing logic
          TrackingLinksUtils.handleAddMore(this);
        }
      },
      handle_add_more_redirect_mode() {
        const linkSelector = document.querySelector("#link-selector");
        if (!linkSelector) return;

        // Build options list with all available platforms
        linkSelector.innerHTML = `<option value="">Select a listening app</option>`;

        // Ensure custom URL is included in redirect mode
        const platformsWithCustom = [...this.all_distribution_platforms];
        if (!platformsWithCustom.find(p => p.pattern === 'custom_url')) {
          platformsWithCustom.unshift({ name: "Custom", pattern: "custom_url" });
        }

        // Use platformsWithCustom instead of all_distribution_platforms
        for (let i = 0; i < platformsWithCustom.length; i++) {
          const platform = platformsWithCustom[i];
          linkSelector.innerHTML += `<option value="${platform.pattern}">${platform.name}</option>`;
        }

        const handleItemAdd = (value, item) => {
          this.distributionLinkSelector.clear();
          this.distributionLinkSelector.destroy();
          this.selectorVisible = false;
          linkSelector.classList.add("hidden");
          TrackingLinksUtils.createLinkElement(value, item, this);

          // In redirect mode, set up a watcher to capture the URL
          if (this.redirect_only) {
            setTimeout(() => {
              const urlInput = document.querySelector(`#${value}-url`);
              if (urlInput) {
                // Remove existing listeners to avoid duplicates
                urlInput.removeEventListener('input', this.handleUrlInput);
                // Add new listener
                urlInput.addEventListener('input', this.handleUrlInput.bind(this));
              }
            }, 100);
          }
        };

        const handleBlur = () => {
          this.distributionLinkSelector.clear();
          this.distributionLinkSelector.destroy();
          this.selectorVisible = false;
          linkSelector.classList.add("hidden");
        };

        linkSelector.classList.remove("hidden");
        this.distributionLinkSelector = new TomSelect("#link-selector", { create: false });
        this.selectorVisible = true;
        this.distributionLinkSelector.on("item_add", handleItemAdd);
        this.distributionLinkSelector.on("blur", handleBlur);
      },
      sync_options() {
        TrackingLinksUtils.syncOptions(this.selectorVisible, this.distributionLinkSelector);
      },
      create_link_element(value, item) {
        TrackingLinksUtils.createLinkElement(value, item, this);
      },
      submit() {
        // In redirect_only mode, validate that the link is proper
        if (this.redirect_only) {
          const linkElements = document.querySelectorAll(".ql-link-el");
          if (linkElements.length === 0) {
            alert('Please add a valid link for the redirect.');
            return;
          }

          const linkElement = linkElements[0];
          const pattern = linkElement.id;
          const urlInput = document.querySelector(`#${pattern}-url`);

          if (!urlInput) {
            alert('Could not find the URL input field. Please try refreshing the page.');
            return;
          }

          const url = urlInput.value;

          if (!url || url.trim() === '') {
            alert('Please enter a valid URL for the redirect link.');
            return;
          }

          // For all platforms, use the validate_link function
          console.log('Validating redirect_only link:', { pattern, url, validate_link_available: typeof validate_link === 'function' });
          if (typeof validate_link === 'function' && validate_link(pattern, url) === false) {
            console.log('Validation failed for:', { pattern, url });
            alert('Please enter a valid URL for this platform.');
            return;
          }
          console.log('Validation passed for:', { pattern, url });

          // Set the redirect_url_string for the TrackingLinksUtils.submit method
          this.redirect_url_string = url;
        }

        TrackingLinksUtils.submit(this, {
          authenticity_token,
          batch_update_url,
          link_type,
          episode_id,
          toast_text,
          tracking_link_ids,
          checkEmptyUrls: true // Edit page requires empty URL validation
        });
      },
      set_error_message(pattern) {
        this.error_text = TrackingLinksUtils.setErrorMessage(this.all_distribution_platforms, pattern);
      },
      clear_error_message() {
        TrackingLinksUtils.clearErrorMessage(this);
      }
    };
  });
});

// Initialize TomSelect for episode selection if episode_id is present
document.addEventListener('DOMContentLoaded', () => {
  const template = document.getElementById('prefix-edit-tracking-links-data');
  if (template) {
    const episode_id = template.dataset.episodeId;
    const episodes = JSON.parse(template.dataset.episodes);

    if (episode_id && episodes.length > 0) {
      const data = new TomSelect('#ql_select_episode', {
        maxItems: 1,
        valueField: 'id',
        labelField: 'title',
        searchField: 'title',
        options: episodes,
        create: false
      });

      data.setValue(episode_id);
    }
  }

  // Handle toast functionality
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const link_info_toast = urlParams.get('link_info_toast');
  const toast = document.querySelector("#toast");
  const toastText = document.querySelector("#toast_text");

  if (link_info_toast === "true") {
    toastText.textContent = "Link info has been changed!";
    toast.classList.remove("hidden");
    setTimeout(function () {
      toast.classList.add("hidden");
    }, 3000);
  }
});
